import { useTypedApiClient } from 'hooks/useTypedApiClient'
import { type Contest } from 'types/api'
import { useMutation, useQueryClient } from '@tanstack/react-query'

interface UsePutLocationSweepstakeProps {
  id: number
  onSuccess?: (data: Contest, variables: Contest) => void
  onError?: (error: Error, variables: Contest) => void
}

export const usePutLocationSweepstakeGroup = ({
  id,
  onSuccess,
  onError,
}: UsePutLocationSweepstakeProps) => {
  const put = useTypedApiClient({
    path: '/admin/contests/{id}/updateLocationSweepstakeGroup',
    method: 'put',
  })
  const queryClient = useQueryClient()

  return useMutation<any, Error, Contest>({
    mutationFn: async (data: Contest) => {
      const response = await put({ ...data, id })
      return response.data
    },
    onSuccess: async (data, variables) => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ['/sweepstakes', id] }),
        queryClient.invalidateQueries({
          queryKey: ['/contests/groupId', data.groupId],
        }),
      ])
      onSuccess?.(data, variables)
    },
    onError,
  })
}
